import { render, staticRenderFns } from "./HistoryItemTypePaymentCancel.vue?vue&type=template&id=b0b603e6&scoped=true&"
import script from "./HistoryItemTypePaymentCancel.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypePaymentCancel.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypePaymentCancel.vue?vue&type=style&index=0&id=b0b603e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b603e6",
  null
  
)

export default component.exports